import React from "react";
import { CellTemplate, Compatible } from "@silevis/reactgrid";
import { TrashIcon } from "@phosphor-icons/react";

import styles from "./brand-header.module.css";
import type { BrandHeaderCellProps } from "./brand-header.type";

const BrandHeader = ({ text, onRemove }: BrandHeaderCellProps) => {
    return (
        <div className={styles.container}>
            <span>{text}</span>

            {onRemove && (
                <button
                    className={styles.button}
                    type="button"
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        onRemove?.();
                    }}
                >
                    <TrashIcon
                        size={14}
                        className={styles.icon}
                        weight="fill"
                    />
                </button>
            )}
        </div>
    );
};

export class BrandHeaderCellTemplate implements CellTemplate<BrandHeaderCellProps> {
    getCompatibleCell(uncompatibleCell: any): Compatible<BrandHeaderCellProps> {
        return {
            ...uncompatibleCell,
            text: uncompatibleCell.text || "",
            value: 0,
            onRemove: uncompatibleCell.onRemove
        };
    }

    render(cell: Compatible<BrandHeaderCellProps>): React.ReactNode {
        return <BrandHeader {...cell} />;
    }
}
